<template>
    <div class="preview-modal" :key="$props.previewRefreshKey">
        <v-btn class="carousel-btn modal-close-btn" color="white" depressed @click="$emit('close')">
            <font-awesome-icon icon="fa-solid fa-x"></font-awesome-icon>
        </v-btn>
        <div class="slide-toolbar p-2 text-center" v-if="previewingIndex > -1 && !$props.readOnly">
            <template v-if="slideSettingsEnabled">
                <!-- <v-btn
                    class="carousel-btn"
                    color="white"
                    depressed
                    :disabled="reversedSlides[previewingIndex]?.loading"
                    @click="toggleSlideSettings"
                >
                    <font-awesome-icon icon="fa-solid fa-sliders-h"></font-awesome-icon>
                </v-btn> -->
                <v-col class="d-flex align-center justify-end p-0" cols="4">
                    <span class="mr-1">Duration:</span>
                    <v-text-field
                        class="slide-duration"
                        outlined
                        hide-details
                        dense
                        type="number"
                        step=".25"
                        @focus="$event => $event.target.select()"
                        :disabled="reversedSlides[previewingIndex]?.loading || isVideoSlide(reversedSlides, previewingIndex)"
                        :append-icon="slideDuration !== null && !isVideoSlide(reversedSlides, previewingIndex) ? 'mdi-close': null"
                        :append-outer-icon="slideDuration != reversedSlides[previewingIndex].slideDuration
                            && !isVideoSlide(reversedSlides, previewingIndex) ? 'mdi-content-save-outline' : null"
                        @click:append="slideDuration = null"
                        @click:append-outer="saveSlideDuration"
                        suffix="sec"
                        :rules="[rules.slideDuration]"
                        :min="minSlideDuration"
                        :max="maxSlideDuration"
                        :placeholder="!slideDuration ? `Auto (${$store.state.tributeVideo.slideDuration})` : ''"
                        v-model="slideDuration"
                        @blur="validateSlideDuration($event, previewingIndex, slideDuration)"
                    />

                </v-col>
            </template>
            <v-spacer />
            <div v-if="!state.isMobile && !state.isContributor" class="edit-button">
                <v-btn
                    class="carousel-btn"
                    color="white"
                    depressed
                    :disabled="reversedSlides[previewingIndex]?.loading"
                    @click="$emit('actionFromPreviewImage', $event, 'download')"
                >
                    <font-awesome-icon icon="fa-regular fa-arrow-down-to-line"></font-awesome-icon>
                </v-btn>
            </div>

            <div
                v-if="isVideoSlide(reversedSlides, previewingIndex) && videoEditingEnabled && !state.isMobile"
                class="edit-button"
            >
                <v-btn
                    class="carousel-btn"
                    color="white"
                    depressed
                    :disabled="
                        (state.isContributor && !reversedSlides[previewingIndex]?.guid) ||
                        reversedSlides[previewingIndex]?.loading
                    "
                    @click="$emit('actionFromPreviewImage', $event, 'toggle-mute')"
                >
                    <font-awesome-icon
                        v-if="reversedSlides[previewingIndex]?.mute"
                        icon="fa-regular fa-volume-slash"
                    ></font-awesome-icon>
                    <font-awesome-icon v-else icon="fa-regular fa-volume"></font-awesome-icon>
                </v-btn>
            </div>

            <div
                v-if="(!isVideoSlide(reversedSlides, previewingIndex) || videoEditingEnabled) && !state.isMobile"
                class="edit-button"
            >
                <v-btn
                    class="carousel-btn"
                    color="white"
                    depressed
                    :disabled="
                        (state.isContributor && !reversedSlides[previewingIndex]?.guid) ||
                        reversedSlides[previewingIndex]?.loading
                    "
                    @click="$emit('actionFromPreviewImage', $event, 'edit')"
                >
                    <font-awesome-icon icon="fa-regular fa-pencil"></font-awesome-icon>
                </v-btn>
            </div>

            <div v-if="!isVideoSlide(reversedSlides, previewingIndex)" class="rotate-button">
                <v-btn
                    class="carousel-btn"
                    color="white"
                    depressed
                    :disabled="
                        isVideoSlide(reversedSlides, previewingIndex) ||
                        selectedContainsVideo ||
                        (state.isContributor && !reversedSlides[previewingIndex]?.guid) ||
                        reversedSlides[previewingIndex]?.loading
                    "
                    @click="$emit('actionFromPreviewImage', $event, 'rotate')"
                >
                    <font-awesome-icon icon="fa-regular fa-rotate-right"></font-awesome-icon>
                </v-btn>
            </div>
            <div class="delete-button">
                <v-btn
                    class="carousel-btn"
                    color="white"
                    depressed
                    :disabled="
                        (state.isContributor && !reversedSlides[previewingIndex]?.guid) ||
                        reversedSlides[previewingIndex]?.loading
                    "
                    @click="$emit('actionFromPreviewImage', $event, 'trash')"
                >
                    <font-awesome-icon style="color: #ef4444" icon="fa-regular fa-trash-can"></font-awesome-icon>
                </v-btn>
            </div>
        </div>
        <div
            class="slide-toolbar slide-settings p-2 text-center"
            :class="{ active: showSlideSettings }"
            v-if="previewingIndex > -1 && reversedSlides[previewingIndex]"
        >
            <v-form v-model="valid">
                <v-container class="flex-grow-1 w-100">
                    <v-row>
                        <v-col class="d-flex align-center" cols="4">
                            <span>Slide {{ getSlideDbIndex(previewingIndex) }} settings:</span>
                            <v-spacer />
                        </v-col>
                        <!-- <v-col class="d-flex align-center justify-end" cols="4">
                        </v-col> -->
                        <v-col class="d-flex align-center justify-end" cols="4">
                            <span class="mr-1">Animation:</span>
                            <v-autocomplete
                                v-model="reversedSlides[previewingIndex]._slideAnimation"
                                :items="slideAnimations"
                                :search-input.sync="animationSearch"
                                dense
                                clearable
                                hide-details
                                hide-selected
                                item-text="name"
                                item-value="id"
                                solo
                            >
                                <template v-slot:no-data>
                                    <v-list-item>
                                        <v-list-item-title> Search through animations </v-list-item-title>
                                    </v-list-item>
                                </template>
                                <template v-slot:selection="{ attr, on, item, selected }">
                                    <v-chip
                                        v-bind="attr"
                                        :input-value="selected"
                                        color="blue-grey"
                                        class="white--text"
                                        v-on="on"
                                    >
                                        <v-icon left> mdi-animation-outline </v-icon>
                                        <span v-text="item.name"></span>
                                    </v-chip>
                                </template>
                                <template v-slot:item="{ item }">
                                    <v-list-item-avatar color="indigo" class="text-h5 font-weight-light white--text">
                                        <v-icon>mdi-transition</v-icon>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        <v-list-item-title v-text="item.name"></v-list-item-title>
                                        <!-- <v-list-item-subtitle v-text="item.symbol"></v-list-item-subtitle> -->
                                    </v-list-item-content>
                                </template>
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                </v-container>
            </v-form>
        </div>
        <v-carousel v-model="previewingIndex" continuous hide-delimiters ref="carousel" @change="onSlideChange">
            <template v-slot:prev="{ on, attrs }">
                <v-btn class="carousel-btn" color="white" depressed v-bind="attrs" v-on="on">
                    <font-awesome-icon icon="fa-solid fa-chevron-left"></font-awesome-icon>
                </v-btn>
            </template>
            <template v-slot:next="{ on, attrs }">
                <v-btn class="carousel-btn" color="white" depressed v-on="on">
                    <font-awesome-icon icon="fa-solid fa-chevron-right"></font-awesome-icon>
                </v-btn>
            </template>

            <v-carousel-item
                v-for="(slide, index) in reversedSlides"
                :key="`${slide.id}-${index}`"
                :eager="eagerIndices.includes(index)"
                :disabled="hasUnsavedChanged"
            >
                <v-sheet elevation="0" rounded height="100%">
                    <div class="carousel-content" :ref="`slidePreview_${index}`">
                        <div class="slide-top-left">
                            <div class="slide-order" v-if="!$props.readOnly">
                                {{ getSlideDbIndex(index) }}
                            </div>
                        </div>
                        <div class="slide-bottom-center">
                            <div class="unsaved-changes-block" v-if="hasUnsavedChanged">
                                Unsaved slide changes. <a @click.prevent="saveSlideDuration">Save</a> or <a @click.prevent="slideDuration = reversedSlides[previewingIndex].slideDuration">discard</a>.
                            </div>
                        </div>
                        <div class="slide-top-right">
                            <div
                                class="white--text"
                                v-if="reversedSlides[previewingIndex]?.mediaType === 1 && !$props.readOnly"
                            >
                                <span v-if="reversedSlides[previewingIndex]?.mute">
                                    <CustomTooltip :tooltipProps="{ top: true }">
                                        <template #activator>
                                            <div>
                                                <span class="mr-2">Muted</span>
                                                <font-awesome-icon
                                                    icon="fa-regular fa-volume-slash"
                                                ></font-awesome-icon>
                                            </div>
                                        </template>
                                        <template #content> This video will be muted in the final render </template>
                                    </CustomTooltip>
                                </span>
                                <span v-else>
                                    <CustomTooltip :tooltipProps="{ top: true }">
                                        <template #activator>
                                            <div>
                                                <span class="mr-2">Not Muted</span>
                                                <font-awesome-icon icon="fa-regular fa-volume"></font-awesome-icon>
                                            </div>
                                        </template>
                                        <template #content> This video will have audio in the final render </template>
                                    </CustomTooltip>
                                </span>
                            </div>
                        </div>
                        <CustomTooltip
                            :class="['slide-user']"
                            :style="{ color: getUploadUserColor(slide) }"
                            :tooltipProps="{ top: true }"
                        >
                            <template #activator>
                                <div class="slide-user-inner">
                                    <font-awesome-icon icon="fa-solid fa-user"></font-awesome-icon>
                                    <span>
                                        {{ slide.uploadUserName | firstName }}
                                    </span>
                                </div>
                            </template>
                            <template #content>
                                <strong class="mr-1">{{ slide.uploadUserName }}</strong>
                                <span v-if="slide.uploadUserRelationship !== slide.uploadUserName">{{
                                    slide.uploadUserRelationship
                                }}</span>
                            </template>
                        </CustomTooltip>

                        <StyledVideojsPlayer
                            v-if="slide.mediaType === 1"
                            :src="handleVideoPreviewUrl(slide.url)"
                            ref="videoPlayer"
                            class="video-preview"
                            :id="`video-preview-${slide.id}`"
                        />

                        <ImageThumbnail
                            v-else
                            :key="`${slide.url}`"
                            :src="slide.url"
                            :preset="'large'"
                            :type="slide.mediaType"
                            :alt="'Slide ' + getSlideDbIndex(index)"
                            class="slide-image"
                            :style="{
                                transform: 'rotate(' + slide.rotation + 'deg)',
                                maxHeight: slide.rotation % 180 === 90 ? '800px' : '100%',
                                maxWidth: slide.rotation % 180 === 90 ? '500px' : '100%',
                            }"
                        />

                        <div v-if="slide?.loading" class="preview-loading-indicator">
                            <v-progress-circular color="#ff530d" size="60" indeterminate></v-progress-circular>
                        </div>
                    </div>
                </v-sheet>
            </v-carousel-item>
        </v-carousel>
    </div>
</template>

<script>
import ImageThumbnail from '../../Media/ImageThumbnail.vue';
import StyledVideojsPlayer from '@/components/videojs/StyledVideojsPlayer.vue';
import CustomTooltip from '@/components/ui/CustomTooltip.vue';
import { debounce } from 'lodash';

function getWrappedAdjacentIndices(arrLength, startIndex, count) {
    // console.time();
    const indices = [];
    for (let i = 1; i <= count; i++) {
        const prevIndex = (startIndex - i + arrLength) % arrLength;
        indices.unshift(prevIndex);
    }
    indices.push(startIndex);
    for (let i = 1; i <= count; i++) {
        const nextIndex = (startIndex + i) % arrLength;
        indices.push(nextIndex);
    }
    // console.timeEnd();
    return indices;
}
export default {
    components: {
        ImageThumbnail,
        StyledVideojsPlayer,
        CustomTooltip,
    },
    inject: ['state'],
    props: [
        'readOnly',
        'previewRefreshKey',
        'reversedSlides',
        'getSlideDbIndex',
        'getUploadUserColor',
        'isVideoSlide',
        'handleVideoPreviewUrl',
        'selectedContainsVideo',
        'videoEditingEnabled',
        'startingIndex',
    ],
    computed: {
        eagerIndices() {
            this.previewRefreshKey;

            if (this.previewingIndex > -1) {
                let eager = getWrappedAdjacentIndices(this.$props.reversedSlides?.length, this.previewingIndex, 5);

                return eager;
            }
            return [];
        },
        hasUnsavedChanged() {
            if (this.isVideoSlide(this.reversedSlides, this.previewingIndex)) {
                return false;
            }
            if (this.slideDuration !== this.reversedSlides?.[this.previewingIndex]?.slideDuration) {
                return true;
            }
            return false;
        }
    },
    data() {
        return {
            showSlideSettings: false,
            slideDuration: null,
            previewingIndex: -1,
            minSlideDuration: 2,
            maxSlideDuration: 60,
            animationSearch: null,
            slideAnimations: [
                {
                    name: 'Fade',
                },
            ],
            valid: null,
            slideSettingsEnabled: true,
            rules: {
                slideDuration: value => {
                    if (value === null) return true;

                    const v = parseFloat(value);
                    if (!isNaN(v)) {
                        return v >= this.minSlideDuration && v <= this.maxSlideDuration;
                    }
                    return false;
                },
            },
        };
    },
    methods: {
        toggleSlideSettings() {
            this.showSlideSettings = !this.showSlideSettings;
        },
        validateSlideDuration($event, index, value) {
            // console.log(event);
            let numVal = parseFloat(value);
            if (!isNaN(numVal)) {
                if (numVal < this.minSlideDuration) {
                    numVal = this.minSlideDuration;
                }
                if (numVal > this.maxSlideDuration) {
                    numVal = this.maxSlideDuration;
                }
                this.slideDuration = numVal;
            } else {
                this.slideDuration = null;
            }
        },
        saveSlideDuration($event) {
          this.$emit('actionFromPreviewImage', $event, 'update-duration', this.slideDuration);
        },
        next() {
            this.$refs.carousel.next();
        },
        prev() {
            this.$refs.carousel.prev();
        },
        async setInitialValue() {
            await this.$nextTick();
            if (this.reversedSlides?.[this.previewingIndex].mediaType === 1) {
                this.slideDuration = this.reversedSlides[this.previewingIndex].duration;
            } else {
                this.slideDuration = this.reversedSlides[this.previewingIndex].slideDuration;
            }
        },
        onSlideChange(val) {
            this.$emit('updatedPreviewIndex', val);
        }
    },
    filters: {
        firstName(text) {
            const words = text?.split(' ');

            if (words.length > 0) return words[0];

            return null;
        },
    },
    mounted() {
        this.previewingIndex = this.$props.startingIndex;
        this.setInitialValue();
    },
    watch: {
        previewingIndex(newIndex, oldIndex) {
            this.setInitialValue();
            if (newIndex !== null && oldIndex !== null && newIndex !== oldIndex) {
                const tmpRef = this.$refs[`slidePreview_${oldIndex}`];

                if (this.isVideoSlide(this.reversedSlides, oldIndex) && tmpRef?.length) {
                    const videoEl = tmpRef[0].querySelector('video');
                    if (videoEl && !videoEl.paused) {
                        console.log('video paused');
                        videoEl.pause();
                    }
                }
            }
        },
        '$props.startingIndex': {
            handler(newVal, oldVal) {
                this.previewingIndex = newVal;
                this.setInitialValue();
            }
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep {
    // .v-carousel {
    //     // width: fit-content;
    // }
    .v-dialog.v-dialog--active:has(.preview-modal) {
        // width: auto;
        box-shadow: none;
    }
    .v-window__next,
    .v-window__prev {
        background: none;
    }
    .carousel-btn {
        .v-btn__content {
            color: $primary-grey;
            font-size: 1.4rem;
            font-weight: bold;
        }
        &.v-btn.v-size--default {
            border: 2px solid $primary-grey;
            padding: 0;
            min-width: 36px;
            width: 48px;
        }
    }

    .v-skeleton-loader__image {
        height: 100%;
    }
    .v-input.slide-duration input {
        text-align: right;
        &::placeholder {
            color: black;
            font-style: italic;
        }
        &:focus,
        &:focus-within {
            &::placeholder {
                opacity: 0;
            }
        }
    }
    .v-input--is-disabled input {
        cursor: not-allowed;
    }
}

.preview-modal {
    position: relative;
    .video-preview {
        width: 100%;
        min-width: 100%;
    }
    .slide-toolbar {
        display: flex;
        gap: 10px;
        justify-content: end;
        background: $light-gray;
        z-index: 2;
        position: relative;
        border-bottom: 2px solid rgba(0, 0, 0, 0.1);

        .v-btn.v-size--default {
            border: 2px solid lighten($primary-grey, 10%) !important;
            padding: 0;
            min-width: 36px;
            width: 48px;
        }

        .edit-button,
        .rotate-button,
        .delete-button {
            &:has(button[disabled='disabled']) {
                cursor: not-allowed;
            }
        }
        &.slide-settings {
            z-index: 1;
            position: absolute;
            top: 0px;
            transition: top ease-in-out 300ms;
            width: 100%;
            height: 50px;
            background: lighten($medium-gray, 30%);
            justify-content: start;
            align-items: center;

            &.active {
                top: 52px;
            }
        }
    }
}
.carousel-content {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    background-color: black;
    max-width: 100%;
    max-height: 100%;
    overflow: hidden;
    position: relative;

    .slide-image {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
    }

    &::v-deep {
        .v-responsive__content {
            width: fit-content;
        }
    }
    img {
        object-fit: contain;
    }
}

.preview-loading-indicator {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;

    display: flex;
    align-items: center;
    justify-content: center;
}

.modal-close-btn {
    position: fixed;
    top: 10px;
    right: 10px;
    margin: auto;
    width: auto;
    &.v-btn:not(.v-btn--round).v-size--default {
        padding: 0;
        min-width: 36px;
        width: 48px;
    }
    @include mobile() {
        bottom: 60px;
        left: 0;
        right: 0;
        top: auto;
    }
}
.slide-user {
    position: absolute;
    background: $light-gray;
    bottom: 10px;
    left: 10px;
    // width: 32px;
    overflow: hidden;
    min-width: 50px;
    max-width: 110px;
    border-radius: 20px;
    height: 32px;
    z-index: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-weight: bold;
    text-transform: capitalize;
    border: 2px solid;
    padding: 0 12px;

    font-size: 0.8rem;
    @include mobile() {
        max-width: min(110px, 57%);
    }

    .slide-user-inner {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        max-width: 100%;
        gap: 4px;

        span {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            margin: 0;
            margin-top: 2px;
        }
    }
}
.slide-top-left {
    z-index: 2;
    top: 8px;
    left: 8px;
    position: absolute;
    display: flex;
    // flex-direction: column;
    flex-direction: row;
    gap: 4px; // align-items: flex-start;

    .duration {
        margin-left: 18px;
        text-wrap: nowrap;
        &:before {
            content: '';
            background: lighten($medium-gray, 16%);
            width: 2px;
            height: 10px;
            bottom: 0;
            position: absolute;
            top: 0;
            margin: auto;
            border-radius: 4px;
            transform: translateX(-10px);
        }
    }
}

.slide-bottom-center,
.slide-top-center,
.slide-top-right {
    z-index: 2;
    top: 8px;
    position: absolute;
    display: flex;
    // flex-direction: column;
    flex-direction: row;
    gap: 4px; // align-items: flex-start;
}
.slide-top-right {
    right: 8px;
}
.slide-top-center {
    right: 0;
    left: 0;
    justify-content: center;
}
.slide-bottom-center {
    bottom: 8px;
    top: auto;
}
.unsaved-changes-block {
    background: lighten($yellow-2, 20%);
    border: $yellow-2 2px solid;
    border-radius: 30px;
    padding: 4px 15px;
    font-size: 0.9rem;
    a {
        font-weight: bold;
        text-decoration: underline;
    }
}
.slide-order {
    min-width: 42px;
    height: 32px;
    background: white;
    border: 1px solid #d1d5db;
    box-shadow: 0px 1px 2px 0px #0000000d;
    color: #6b7280;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    font-family: 'Inter', sans-serif;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 2.5%;
    padding: 0 12px;
}
</style>
